import ActionType from '../action-types';

// eslint-disable-next-line import/prefer-default-export
export const setHeader = (headerName) => {
  return (dispatch) => {
    dispatch({
      type: ActionType.SET_HEADER,
      payload: headerName
    });
  };
};

export const setSubHeader = (headerName) => {
  return (dispatch) => {
    dispatch({
      type: ActionType.SET_SUB_HEADER,
      payload: headerName
    });
  };
};

export const setBackLink = (link) => {
  return (dispatch) => {
    dispatch({
      type: ActionType.SET_BACK_LINK,
      payload: link
    });
  };
};
